export { ProjectsActions } from './projects.actions';
export { ProjectsReducer } from './projects.reducer';
export { ProjectsState } from './projects.state';



// WEBPACK FOOTER //
// ./src/states/projects/index.ts